<template>
    <div v-if="!disabledStepsCustomer" class="row" id="navContrato">
        <div class="pageSignature col-12">
            <nav :class="[
                'nav nav-tabs nav-stacked nav-contract',
                navContractSelected == 1 ? 'contract' : navContractSelected == 2 ? 'letter' : navContractSelected == 3 ? 'attachImg' : '']">
                <div v-for="(i, index) in navContract" :key="index"
                    :class="[
                        'nav-link',
                        navContractSelected == i.id ? 'active' :'',
                        i.disabled ? 'disabled' : '',
                        i.id == 1 ? 'includeContratc' : '',
                        i.id == 2 ? 'includeLetter' : '',
                        i.id == 3 ? 'includeAttachImg' : ''
                    ]"
                >
                    <a href="#" @click.prevent="setNavContractSelected(i)">
                        <i :class="i.icon"></i>
                        {{ i.name }}
                    </a>
                    <input type="checkbox" id="includeContratc" v-model="form.checked" v-if="i.id == 1 " @change="includeContratc"/>
                    <input type="checkbox" id="includeLetter" v-model="form.letter" v-if="i.id == 2" @change="includeLetter"/>
                    <input type="checkbox" id="includeAttachImg" v-model="form.isAttacImg" v-if="i.id == 3" @change="includeAttachImg"/>
                </div>
            </nav>
        </div>
    </div>
</template>
<script>
export default {
    name: 'navContract',
    props: {
        contract: {
            type: Object,
            required: true
        },
        disabledStepsCustomer: {
            type: Boolean,
            default: false
        },
        propSelectedIndex: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            navContract: [
                { id: 1, name: 'Need a Contract?', icon: 'fas fa-file-contract', disabled: false, checked: false },
                { id: 2, name: 'Need a Letter?', icon: 'fas fa-file-alt', disabled: false, checked: false },
                { id: 3, name: 'Attach Image?', icon: 'fas fa-images', disabled: false, checked: false },
                // { id: 3, name: 'Other Documents?', icon: 'fas fa-file-pdf', disabled: true, checked: false },
            ],
            navContractSelected: this.propSelectedIndex,
            form: this.contract,
        };
    },
    methods: {
        setNavContractSelected(i) {
            if (i.disabled) return;
            this.$emit('updateNavContract', i);
            this.navContractSelected = i.id;
        },
        includeContratc() {
            if(this.form.checked) {
                this.navContractSelected = 1;
                this.navContract[0].checked = true;
            }else {
                this.navContract[0].checked = false;
            }
            this.$emit('includeToDocument', {
                "type": "contract",
                "value": this.form.checked,
                "tabActive": this.navContractSelected,
            });
        },
        includeLetter() {
            if(this.form.letter) {
                this.navContractSelected = 2;
                this.navContract[1].checked = true;
            }else {
                // this.navContractSelected = 0;
                this.navContract[1].checked = false;
            }
            this.$emit('includeToDocument', {
                "type": "letter",
                "value": this.form.letter,
                "tabActive": this.navContractSelected,
            });
        },
        includeAttachImg() {
            if(this.form.isAttacImg) {
                this.navContractSelected = 3;
                this.navContract[1].isAttacImg = true;
            }else {
                // this.navContractSelected = 0;
                this.navContract[1].isAttacImg = false;
            }
            this.$emit('includeToDocument', {
                "type": "attachImg",
                "value": this.form.isAttacImg,
                "tabActive": this.navContractSelected,
            });
        },
    },
    watch: {
        'contract': {
            deep: true,
            handler(newVal, oldVal) {
                for (const key in newVal) {
                    if (Object.prototype.hasOwnProperty.call(newVal, key)) {
                        if (newVal[key] !== oldVal[key]) {
                            this.form[key] = newVal[key];
                            console.log('Contract updated:', key, newVal[key]);
                        }
                    }
                }
            },
        },
    },
};
</script>
